import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { ButtonBase, Stack, Typography } from '@mui/material';
import PaiDotLoader from 'features/ui/base-components/pai-dot-loader';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  dense?: boolean;
  handleOpenAutoSyncProcessingDialog(): void;
}

const AutoSyncIndicator: React.FC<Props> = ({ dense = false, handleOpenAutoSyncProcessingDialog }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <ButtonBase className={classes.autoSyncIndicator} onClick={handleOpenAutoSyncProcessingDialog}>
      <Stack direction={'row'} alignItems={'center'} gap={2}>
        <LinkedInIcon className={classes.icon} />
        {!dense ? <Typography className={classes.text}>{t('autoSyncIndicatorText')}</Typography> : null}
        <PaiDotLoader size={'small'} inline={true} />
      </Stack>
    </ButtonBase>
  );
};

const useStyles = makeStyles()((theme) => ({
  autoSyncIndicator: {
    padding: '6px 16px',
    background: '#FFF',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '6px',
    '&:hover': {
      background: theme.palette.action.hover,
    },
  },
  icon: {
    fontSize: theme.typography.pxToRem(20),
    color: '#0A66C2',
  },
  text: {
    fontSize: theme.typography.pxToRem(12),
  },
}));

export default AutoSyncIndicator;
